// Import Chakra UI extendTheme
import { extendTheme } from "@chakra-ui/react";

// Create theme with improved defaults for buttons, inputs, etc. and permanent dark mode
const theme = extendTheme({
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
      },
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: "md",
          color: "white",
        },
      },
    },
    Table: {
      variants: {
        simple: {
          th: {
            color: "gray.100",
            fontSize: "xs",
            fontWeight: "bold",
            textTransform: "none", // Preserve case for sigma characters
            textAlign: "center", // Center all headers
          },
          td: {
            color: "white",
            fontSize: "sm",
            padding: "4px 2px", // Reduce horizontal padding
          }
        },
      },
    },
  },
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
});

export default theme; 